import graphql from "babel-plugin-relay/macro";
import { useMutation } from "react-relay";

import { getSquarePaymentErrorMessage } from "@whoosh/utilities/src/Square/squareErrorMessages";

import {
  ConfirmDraftPackageInput,
  useConfirmDraftMemberPackageMutation,
} from "./__generated__/useConfirmDraftMemberPackageMutation.graphql";

export const useConfirmDraftMemberPackage = () => {
  const [confirmDraftMemberPackageMutation, isConfirming] =
    useMutation<useConfirmDraftMemberPackageMutation>(
      useConfirmDraftMemberPackageMutationString
    );

  const confirmDraftMemberPackage = (
    input: ConfirmDraftPackageInput,
    onComplete?: () => void,
    onError?: (error: Error) => void
  ) => {
    confirmDraftMemberPackageMutation({
      variables: { input },
      onCompleted: (res) => {
        if (res.confirmDraftPackage?.success) {
          onComplete && onComplete();
        } else {
          const errorCode = res.confirmDraftPackage?.errors?.[0]?.code;
          const error = new Error(
            getSquarePaymentErrorMessage(errorCode) ||
              res.confirmDraftPackage?.errors?.[0]?.message ||
              "Unknown error"
          );
          if (onError) {
            onError(error);
          }
        }
      },
      onError: (error) => {
        if (onError) {
          onError(error);
        }
      },
    });
  };

  return [confirmDraftMemberPackage, isConfirming] as const;
};

const useConfirmDraftMemberPackageMutationString = graphql`
  mutation useConfirmDraftMemberPackageMutation(
    $input: ConfirmDraftPackageInput!
  ) {
    confirmDraftPackage(input: $input) {
      success
      errors {
        code
        field
        message: code
      }
      memberPackage {
        id
      }
    }
  }
`;
